import React, { useState, useEffect, useRef } from 'react';
import OrderTab from 'components/order-management/base/OrderTab';

import { Form, Drawer, Space, Button } from 'antd';

import SPDynamicFormRender from 'components/base/SPDynamicFormRender';

import { useOrderList } from 'hooks/order-management/order-list';

import { JSONS } from 'jsons';
import emiter, {
	_EVENTS,
	EVENT_VEHICLE_ADD_CAR,
	EVENT_VEHICLE_EDIT_CAR, EVENT_VEHICLE_TYPE,
	EVENT_VEHICLE_VIEW_CAR
} from '../../../../events';

interface IComponentProps {
	enums?: any;
	permission?: any;
}
const SPDrawer: React.FC<IComponentProps> = props => {
	// 组件所需枚举值
	const { enums, permission } = props;
	// load后的数据值，用来为非表单类组件使用，如状态显示
	const dataRef = useRef({});
	// form引用
	const [mainForm] = Form.useForm();
	// Drawer打开状态
	const [open, setOpen] = useState(false);
	// 是否为只读态，查看场景
	const [disabled, setDisabled] = useState(false);
	// Drawer的操作栏
	const [actionBar, setActionBar] = useState(<></>);
	// 根据只读态，编辑态，标题有所不同。如编辑订单，查看订单等
	const [title, setTitle] = useState('');


	// todo:hard code,rebuild to consts
	const drawerWidth = '85%';

	const drawerView = JSONS.orderManagement.orderList.drawerView;

	const { drawerSubmit, details, setDetails } = useOrderList();

	const onOpen = (data: any = {}) => {
		setDetails(data.detail);
		const drawerInfo = data.drawerInfo;
		dataRef.current = data;
		mainForm.resetFields();
		mainForm.setFieldsValue(data);
		setOpen(true);
		setDisabled(drawerInfo.disabled);
		// setActionBar(<ActionBar />);
		setTitle(drawerInfo.title);
	};

	const onClose = () => {
		setOpen(false);
		dataRef.current = {};
		mainForm.resetFields();
		setDisabled(false);
		// setActionBar(ActionBar);
		setTitle('');
	};

	const onRefresh = (data: any = {}) => {
		setDetails(data.detail);
	};

	const onFinish = () => {
		mainForm.validateFields().then(async (fieldsValue: any) => {
			const values = mainForm.getFieldsValue();
			await drawerSubmit(values, dataRef.current);
			onClose();
		});
	};

	useEffect(() => {
		emiter.on(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.VIEW, onOpen);
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.ADD, onOpen);
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT, onOpen);
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.CLOSE_DRAW, onClose);
		emiter.on(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.REFRESH, onRefresh);
		return () => {
			emiter.removeAllListeners(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.VIEW)
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.ADD)
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT)
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.CLOSE_DRAW)
			emiter.removeAllListeners(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.REFRESH)
		}
	}, []);

	return (
		<>
			<Drawer title={title} width={drawerWidth} onClose={onClose} open={open} destroyOnClose extra={actionBar}>
				{/* <Form form={mainForm} labelCol={{ span: 4 }} disabled={disabled}> */}
					<OrderTab permission={permission} data={details} enums={enums} echoData={details}></OrderTab>
				{/* </Form> */}
			</Drawer>
		</>
	);
};

export default SPDrawer;
